export const UPDATE_USERORGANIZATIONS_LIST = 'UPDATE_USERORGANIZATIONS_LIST';
export const UPDATE_USERORGANIZATION = 'UPDATE_USERORGANIZATION';
export const UPDATE_USERORGANIZATIONS_TOTAL_COUNT = 'UPDATE_USERORGANIZATIONS_TOTAL_COUNT';
export const UPDATE_ROLES_LIST = 'UPDATE_ROLES_LIST';
export const SAVE_USERORGANIZATIONS = 'SAVE_USERORGANIZATIONS';
export const DELETE_USERORGANIZATION = 'DELETE_USERORGANIZATION';
export const UPDATE_CREATEDBY_USER_LIST = 'UPDATE_CREATEDBY_USER_LIST';
